import styled from 'styled-components'
import { Tree } from 'antd'
import { COLORS } from 'theme'

export const TreeDiv = styled.div`
  .ant-tree .ant-tree-treenode {
    padding: 0 0 15px 0;
  }
`
export const AntdTree = styled(Tree)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
